import { API_URL } from '../config';

export const registrationLink = `${API_URL}/registration/carrier`;
